import { render, staticRenderFns } from "./OfferPage.vue?vue&type=template&id=40d5695a"
import script from "./OfferPage.vue?vue&type=script&lang=js"
export * from "./OfferPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports